import axios from 'axios';
import {
  LIST_ORG_REQUEST,
  LIST_ORG_SUCCESS,
  LIST_ORG_FAIL,
  GET_ORG_STATUS_REQUEST,
  GET_ORG_STATUS_SUCCESS,
  GET_ORG_STATUS_FAIL,
  ADD_ORG_REQUEST,
  ADD_ORG_SUCCESS,
  ADD_ORG_FAIL,
  UPDATE_ORG_REQUEST,
  UPDATE_ORG_SUCCESS,
  UPDATE_ORG_FAIL,
  DELETE_ORG_REQUEST,
  DELETE_ORG_SUCCESS,
  DELETE_ORG_FAIL,
} from '../constants/orgConstants';
// import { BASE_URL } from './ip';
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const orgsListAction =
  (page = 1, limit = 100) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: LIST_ORG_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();
      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
          'Content-Type': 'application/json',
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/org?page=${page}&limit=${limit}`,
        config
      );

      dispatch({
        type: LIST_ORG_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: LIST_ORG_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };

export const orgStatusAction = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ORG_STATUS_REQUEST });

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.get(`${BASE_URL}/gyms/getStatus`, config);

    dispatch({
      type: GET_ORG_STATUS_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: GET_ORG_STATUS_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};

export const addOrgAction = (formData) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADD_ORG_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.post(
      `${BASE_URL}/users/custom-onboard`,
      formData,
      config
    );

    dispatch({
      type: ADD_ORG_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: ADD_ORG_FAIL,
      payload: err.response && err.response.data ? err.response.data : err,
    });
  }
};

export const updateOrgAction =
  (id, formData) => async (dispatch, getState) => {
    try {
      dispatch({ type: UPDATE_ORG_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();
      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
          'Content-Type': 'application/json',
        },
      };

      const { data } = await axios.patch(
        `${BASE_URL}/org/${id}`,
        formData,
        config
      );

      dispatch({
        type: UPDATE_ORG_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: UPDATE_ORG_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };

export const updateOrgLogoAction =
  (id, formData) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
          'Content-Type': 'application/json',
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/users/upload-logo/${id}`,
        formData,
        config
      );

      return data;
    } catch (err) {
      return err.response && err.response.data.message
        ? err.response.data.message
        : err.message;
    }
  };

export const deleteOrgAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: DELETE_ORG_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'application/json',
      },
    };

    await axios.delete(`${BASE_URL}/org/${id}`, config);

    dispatch({ type: DELETE_ORG_SUCCESS, payload: { status: 'success' } });
  } catch (err) {
    dispatch({
      type: DELETE_ORG_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};
